import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/components/Layout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: function () {
      return import('../views/LoginView.vue')
    },
    meta: { title: '登录' }
  },
  {
    path: "/admin",
    name: "admin",
    meta: { title: "首页", requiresAuth: true },
    redirect: "/admin",
    component: Layout,
    children:[
      {
        path: '/store_info',
        name: '/store_info',
        component: function () {
          return import('../views/store/ListView.vue')
        },
        meta: { title: '门店信息' }
      },
      {
        path: '/users',
        name: 'users',
        component: function () {
          return import('../views/set/AccountManagement.vue')
        },
        meta: { title: '账号管理' }
      },
      {
        path: '/insertaccount',
        name: 'insertaccount',
        component: function () {
          return import('../views/set/InsertAccount.vue')
        },
        meta: { title: '新增账号' }
      },
      {
        path: '/logs',
        name: 'logs',
        component: function () {
          return import('../views/set/OperationLog.vue')
        },
        meta: { title: '操作日志' }
      },
      {
        path: '/roles',
        name: 'roles',
        component: function () {
          return import('../views/set/RolesView.vue')
        }
      },
      {
        path: '/insert_roles',
        name: 'insert_roles',
        component: function () {
          return import('../views/set/InsertRoles.vue')
        }
      },
      {
        path: '/point_products',
        name: 'point_products',
        component: function () {
          return import('../views/goods/explosive/pointView.vue')
        },
        meta: { title: '海金商品列表' }
      },
      {
        path: '/products',
        name: 'products',
        component: function () {
          return import('../views/goods/explosive/listView.vue')
        },
        meta: { title: '商品列表' }
      },
      {
        path: '/exp_products',
        name: 'exp_products',
        component: function () {
          return import('../views/goods/explosive/explosiveLocal.vue')
        },
        meta: { title: '海斛商品列表' }
      },
      {
        path: '/menber',
        name: 'menber',
        component: function () {
          return import('../views/menber/menberList.vue')
        },
        meta: { title: '会员列表' }
      },
      {
        path: '/vipmenber',
        name: 'vipmenber',
        component: function () {
          return import('../views/menber/vipmenberView.vue')
        },
        meta: { title: 'VIP会员列表' }
      },
      {
        path: '/member_detail',
        name: 'member_detail',
        component: function () {
          return import('../views/menber/detailView.vue')
        },
        meta: { title: '会员详情' }
      },
      {
        path: '/exp_order',
        name: 'exp_order',
        component: function () {
          return import('../views/order/goods/exp_order.vue')
        },
        meta: { title: '订单列表' }
      },
      {
        path: '/cash_order',
        name: 'cash_order',
        component: function () {
          return import('../views/order/goods/cash_order.vue')
        },
        meta: { title: '普通订单' }
      },
      {
        path: '/point_order',
        name: 'point_order',
        component: function () {
          return import('../views/order/goods/point_order.vue')
        },
        meta: { title: '海金订单' }
      },
      {
        path: '/erp_order',
        name: 'erp_order',
        component: function () {
          return import('../views/order/erp/erp_order.vue')
        },
        meta: { title: 'erp订单' }
      },
      {
        path: '/abn_order',
        name: 'abn_order',
        component: function () {
          return import('../views/order/abnormal/abn_order.vue')
        },
        meta: { title: '异常订单' }
      },
      {
        path: '/after_sale_cancel_order',
        name: 'after_sale_cancel_order',
        component: function () {
          return import('../views/order/afterSales/after_sale_cancel_order.vue')
        },
        meta: { title: '取消订单' }
      },
      {
        path: '/after_sale_order',
        name: 'after_sale_order',
        component: function () {
          return import('../views/order/afterSales/after_sale_order.vue')
        },
        meta: { title: '售后订单' }
      },
      {
        path: '/after_sale_order_detail',
        name: 'after_sale_order_detail',
        component: function () {
          return import('../views/order/detail/after_detail.vue')
        },
        meta: { title: '售后详情' }
      },
      {
        path: '/vip_order',
        name: 'vip_order',
        component: function () {
          return import('../views/order/member/vip_order.vue')
        },
        meta: { title: '会员订单' }
      },
      {
        path: '/recharge_order',
        name: 'recharge_order',
        component: function () {
          return import('../views/order/member/recharge_order.vue')
        },
        meta: { title: '充值订单' }
      },
      {
        path: '/cash_order_detail',
        name: 'cash_order_detail',
        component: function () {
          return import('../views/order/detail/order_detail.vue')
        },
        meta: { title: '订单详情' }
      },
      {
        path: '/exports',
        name: 'exports',
        component: function () {
          return import('../views/set/exports.vue')
        },
        meta: { title: '导出记录' }
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  // beforeEach是router的钩子函数，在进入路由前执行
  if (to.meta.title) {
    // 设置标题
    document.title = to.meta.title;
  }
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!localStorage.getItem('token_store')) {
      router.push({ path: "/", replace: true });
    }
    next();
  }else{
    next();
  }
});

export default router
